/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';

interface ISupportedByProps {
  logoSrc: string;
  altTxt: string;
}

export default function SupportedBy(props: ISupportedByProps): ReactElement {
  return (
    <div className="col-auto">
      <div className="row logo-container">
        <div className="col">
          <h3>supported by</h3>
        </div>
        <div className="col">
          <img className="logo" src={props.logoSrc} alt={props.altTxt} />
        </div>
      </div>
    </div>
  );
}
